<template>
  <div class="cs-studyAbroad-step1">
    <div>
      <el-row class="cs-accountInfo-row" style="line-height: 32px;">
        <el-col :span="2">
          <span class="cs-label">业务类型:</span>
        </el-col>
        <el-col :span="14">
          <el-select v-model="dataIn.businessType" size="small" placeholder="请选择业务类型" @change="onBusinessTypeChange">
            <el-option v-for="item in GLOBAL.enumBusinessType.getOptions()" :key="item.key" :label="item.desc" :value="item.value"
              :disabled="businessTypeDisabled(item.value)" />
          </el-select>
        </el-col>
      </el-row>
      <el-row class="cs-accountInfo-row margin-top-10" style="line-height: 32px;">
        <el-col :span="2">
          <span class="cs-label">归属地:</span>
        </el-col>
        <el-col :span="14">
          <el-select v-model="dataIn.countryCode" size="small" placeholder="请选择归属地" @change="onCountryCodeChange">
            <el-option v-for="item in GLOBAL.enumCountryCode.getOptions()" :key="item.key" :label="item.desc" :value="item.value" />
          </el-select>
        </el-col>
      </el-row>
    </div>
    <br />
    <div>
      <el-button v-if="!isReadonly" :disabled="dataIn.countryCode === null" size="medium" type="primary" @click="onEditServices">添加/编辑服务</el-button>
      <span v-if="dataIn.countryCode === null" class="choose-country-tip">
        <i class="el-icon-warning"></i>
        <span>请先选择归属地</span>
      </span>
    </div>
    <serviceList :isReadonly="isReadonly" :contractList="contractList" :dataIn="serviceListData"></serviceList>
    <serviceSelector v-if="dialogServiceSelectorVisible" :visible="dialogServiceSelectorVisible" :data="serviceSelectorData"
      @close="onDialogServiceSelectorClose" @change="onServiceChange" />
  </div>
</template>

<style lang="scss" scoped>
.cs-studyAbroad-step1 {
  padding-top: 20px;
}

.choose-country-tip {
  margin-left: 5px;
  color: gray;
}
</style>

<script>
import { getCurrencyPrice } from "@/config/mUtils";
import { calculateQuantityTotalBySI } from "@/core/studyAbroadHelper";
import { getContractsDict } from "@/service/contract.service";

const mixin_generalMethods = {
  methods: {
    calculateTotalPrice(unitPrice, serivceItem) {
      let quantityTotal = calculateQuantityTotalBySI(serivceItem);
      return unitPrice * quantityTotal;
    },
  },
};

export default {
  mixins: [mixin_generalMethods],
  props: {
    isReadonly: Boolean,
    dataIn: {
      studentId: Number,
      workflowId: Number,
      currency: Number,
      isBottomPriceMode: Boolean,
      channelId: Number,
      businessType: Number,
      countryCode: Number,
      serviceListData: {
        serviceList: Array,
      },
    },
  },
  data() {
    return {
      dialogServiceSelectorVisible: false,
      payeeTypeDisabled: false,
      contractList: [],
      serviceSelectorData: {},
      serviceListData: {},
    };
  },
  components: {
    serviceList: () => import("./serviceList"),
    serviceSelector: () => import("../serviceSelector"),
  },
  computed: {},
  created() {
    this.init();
  },
  methods: {
    async loadContractList() {
      if (!this.dataIn.businessType) {
        this.contractList = [];
        return;
      }

      let contractTypes = [];
      if (this.dataIn.businessType === this.GLOBAL.enumBusinessType.ToB) {
        contractTypes.push(this.GLOBAL.contractType.studyAbroadSpeedup, this.GLOBAL.contractType.studyAbroadChannel);
      } else {
        contractTypes.push(this.GLOBAL.contractType.studyAbroadSpeedup);
      }
      try {
        let result = await getContractsDict(contractTypes);
        if (!!result && result.success) {
          let newContractList = [];
          Object.entries(result.data).forEach(([key, value]) => {
            newContractList = newContractList.concat(value);
          });
          this.contractList = newContractList;
        } else {
          this.contractList = [];
        }
      } catch (error) {
        this.contractList = [];
      }
    },
    init() {
      this.loadContractList();

      if (!!this.dataIn && !!this.dataIn.studentId) {
        this.serviceListData = this.dataIn.serviceListData;
        // if (!this.dataIn.workflowId) {
        //   this.showSelectorDialog();
        // }
      }
    },
    resetAllServiceItemPrice() {
      this.dataIn.currency = this.GLOBAL.enumCountryCode.getCurrency(
        this.dataIn.countryCode
      );
      this.dataIn.serviceListData.serviceList.forEach((i) => {
        i.info.currency = this.dataIn.currency;

        i.info.itemList.forEach((j) => {
          let unitPrice = 0;
          let totalPrice = 0;
          if (
            this.dataIn.businessType === this.GLOBAL.enumBusinessType.ToB &&
            this.dataIn.isBottomPriceMode
          ) {
            unitPrice = getCurrencyPrice(
              this.dataIn.currency,
              j.modelData.BottomPriceCAD,
              j.modelData.BottomPriceCNY
            );
          } else {
            unitPrice = getCurrencyPrice(
              this.dataIn.currency,
              j.modelData.SalePriceCAD,
              j.modelData.SalePriceCNY
            );
          }
          totalPrice = this.calculateTotalPrice(unitPrice, j.modelData);
          j.price = totalPrice;
        });
      });
    },
    resetAllServiceContract() {
      this.dataIn.serviceListData.serviceList.forEach((i) => {
        i.model.contractId = 0;
      });
    },
    onBusinessTypeChange() {
      this.resetAllServiceItemPrice();

      this.loadContractList();
      this.resetAllServiceContract();
    },
    onCountryCodeChange() {
      this.resetAllServiceItemPrice();
    },
    businessTypeDisabled(value) {
      return value == 1 && !this.dataIn.channelId;
    },

    onEditServices() {
      this.showSelectorDialog();
    },
    showSelectorDialog() {
      this.serviceSelectorData = {
        currency: this.dataIn.currency,
        isBottomPriceMode: this.dataIn.isBottomPriceMode,
        channelId: this.dataIn.channelId,
        businessType: this.dataIn.businessType,
        selectedServices: this.serviceListData.serviceList.map((i) => ({
          id: i.info.serviceId,
          selectedServiceItems: i.info.itemList.map((j) => j.serviceItemId),
        })),
      };
      this.dialogServiceSelectorVisible = true;
    },
    onDialogServiceSelectorClose() {
      this.dialogServiceSelectorVisible = false;
    },
    onServiceChange(data) {
      let list = data.map((i) => {
        let serviceId = i.Id;
        let existingService = null;
        if (!!this.serviceListData.serviceList) {
          existingService = this.serviceListData.serviceList.find(
            (x) => x.info.serviceId == serviceId
          );
        }
        let id = 0;
        let model = {
          startDate: "",
          contractId: 0,
          discountPercentage: "",
          cashDecreasedAmount: 0,
          comment: "",
        };

        if (!!existingService) {
          id = existingService.Id;
          model = existingService.model;
        }

        let serviceData = {
          id: id,
          info: {
            serviceId: serviceId,
            serviceName: i.Name,
            currency: this.dataIn.currency,
            itemList: i.ServiceItems.map((j) => {
              let serviceItemId = j.Id;
              let existingItem = null;
              if (!!existingService) {
                existingItem = existingService.info.itemList.find(
                  (x) => x.serviceItemId == serviceItemId
                );
              }
              let id = 0;
              if (!!existingItem) {
                id = existingItem.Id;
              }

              let unitPrice = 0;
              let totalPrice = 0;
              if (this.dataIn.businessType === this.GLOBAL.enumBusinessType.ToB && this.dataIn.isBottomPriceMode) {
                unitPrice = getCurrencyPrice(
                  this.dataIn.currency,
                  j.BottomPriceCAD,
                  j.BottomPriceCNY
                );
              } else {
                unitPrice = getCurrencyPrice(
                  this.dataIn.currency,
                  j.SalePriceCAD,
                  j.SalePriceCNY
                );
              }
              totalPrice = this.calculateTotalPrice(unitPrice, j);

              let serviceItemData = {
                id: id,
                serviceItemId: serviceItemId,
                name: j.Name,
                price: totalPrice,
                modelData: {
                  SalePriceCAD: j.SalePriceCAD,
                  SalePriceCNY: j.SalePriceCNY,
                  BottomPriceCAD: j.BottomPriceCAD,
                  BottomPriceCNY: j.BottomPriceCNY,
                  RangeLimitEnable: j.RangeLimitEnable,
                  RangeLimitType: j.RangeLimitType,
                  RangeLimitValue: j.RangeLimitValue,
                  CountLimitEnable: j.CountLimitEnable,
                  CountLimitType: j.CountLimitType,
                  CountLimitValue: j.CountLimitValue,
                  TimeLimitEnable: j.TimeLimitEnable,
                  TimeLimitType: j.TimeLimitType,
                  TimeLimitValue: j.TimeLimitValue,
                },
              };
              return serviceItemData;
            }),
          },
          model: model,
        };
        return serviceData;
      });

      this.serviceListData.serviceList = list;
      this.dialogServiceSelectorVisible = false;
    },
  },
  watch: {
    dataIn: function () {
      this.init();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/studyAbroad/workflow/step1.vue